import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import { Utils } from '@/assets/js/utils.js'
import wx from 'weixin-js-sdk'

Vue.use(Router)

const router = new Router({
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
	routes: [
		{
			path: '/',
			redirect: '/home',
		},
		{
			path: '/home',
			name: 'home',
			component: Home,
		},
		{
			path: '/code',
			name: 'code',
			// this generates a separate chunk (n5-holiday-podium.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "n5-holiday-podium" */ './views/Code.vue'),
		},
		{
			path: '/result',
			name: 'result',
			component: () => import(/* webpackChunkName: "n5-holiday-podium" */ './views/Result.vue'),
			children: [
				{
					path: '/over',
					name: 'over',
					component: () => import(/* webpackChunkName: "n5-holiday-podium" */ './components/over/Over.vue'),
				},
				{
					path: '/full',
					name: 'full',
					component: () => import(/* webpackChunkName: "n5-holiday-podium" */ './components/over/Full.vue'),
				},
				{
					path: '/item-full',
					name: 'item-full',
					component: () =>
						import(/* webpackChunkName: "n5-holiday-podium" */ './components/over/ItemFull.vue'),
				},
			],
		},
		{
			path: '*',
			component: () => import(/* webpackChunkName: "n5-holiday-podium" */ './views/NotFound.vue'),
		},
	],
})

router.beforeEach(async (to, from, next) => {
	const localData = JSON.parse(localStorage.getItem('n5-holiday-podium'))
	let channel = Utils.parseQuery().channel || to.query.channel || 'ds'
	let discern = to.query.discern || (localData && localData.discern)
	let sceneId = to.query.sceneId || (localData && localData.sceneId)
	// if (to.name === 'home' && discern) {
	//   next({ path: '/code', query: { discern, sceneId } })
	// } else
	if (to.name === 'code' && !discern) {
		location.href = '?channel=' + channel + '&sceneId=' + sceneId
	} else {
		next()
	}
})
router.afterEach(() => {
	wx.hideOptionMenu()
})
export default router
